// extracted by mini-css-extract-plugin
module.exports = {"shp2-detail-J":"J_shp2-detail-J__1Mk_p"};